export default __webpack_public_path__ + "static/media/left-alone.96eefd6f.jpg";